//Styles
// import { VideoMobile } from "../VideoMobile";
import "./QuestionOne.scss";

export const QuestionOne = ({ nextStep }) => {
  const handleClick = () => {
    nextStep();
  };
  return (
    <div className="global__wrapper">
      {/* <VideoMobile /> */}
      <div className="form__global">
        <h2 className="title__global">
          Do you want to meet charming and open-minded people?
        </h2>
        <div className="input__wrapper">
          <label className="container-label">
            <input
              className="input"
              type="radio"
              name="gender"
              onClick={(e) => handleClick(e)}
            />
            <div className="skip">Skip</div>
          </label>
          <label className="container-label">
            <input
              className="input"
              type="radio"
              name="gender"
              onClick={(e) => handleClick(e)}
            />
            <div className="yes">Yes</div>
          </label>
        </div>
      </div>
    </div>
  );
};
